// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "./lazy-background.js"
import "./menu.js"
import AOS from "aos"

AOS.init();

// In-place contact form submission
(function() {
  function showContactSuccess(formEl) {
    formEl.style.display = 'none';
    var wrapper = formEl.closest('.contact-form-wrapper');
    if (wrapper) {
      var successEl = wrapper.querySelector('.contact-form-success');
      if (successEl) successEl.style.display = '';
    }
  }

  function bindContactForm(formEl) {
    formEl.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = formEl.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }

      var tokenEl = formEl.querySelector('[name="authenticity_token"]');
      var token = tokenEl ? tokenEl.value : '';

      fetch(formEl.action, {
        method: 'POST',
        headers: { 'X-CSRF-Token': token, 'Accept': 'application/json' },
        body: new FormData(formEl)
      })
      .then(function() { showContactSuccess(formEl); })
      .catch(function() { showContactSuccess(formEl); });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.php-email-form').forEach(bindContactForm);
  });
})();



